/**
 * 文本颜色动画
 */
import fvAnimation from "./fvAnimation"
export default class fvTextColor extends fvAnimation {
    constructor(shape){
        super(shape,"fvTextColor");
        this.colorOldColor = this.shape.color;
        this.sizeFunction = AsyncFunction("return " + this.expression);
    }

    async run(canvas,value){
        //if(value == false) return;
        var size = await this.executionScript(this.sizeFunction);
        for(var i in this.changeColor){
            if(this.changeColor[i].Twinkel == true){
                this.shape.color = this.changeColor[i].FlashingColor;
                if(this.shape.color == this.changeColor[i].FlashingColor){
                    this.shape.color=this.changeColor[i].TwinkelColor;
                }else{
                    this.shape.color = this.changeColor[i].FlashingColor ;
                }
            }else{
                if(size >= this.changeColor[i].MinValue && size <= this.changeColor[i].MaxValue){
                    this.shape.color = this.changeColor[i].FlashingColor;
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvTextColor.js